/* This file was generated automatically. Do not edit manually. */

import { createGeneralCitiesRepository as generalCities } from './generalCities';
import { createGeneralEnterprisesRepository as generalEnterprises } from './generalEnterprises';
import { createGeneralExchangeRatesRepository as generalExchangeRates } from './generalExchangeRates';
import { createGeneralMerchantSubscriptionsRepository as generalMerchantSubscriptions } from './generalMerchantSubscriptions';
import { createGeneralOnboardingRepository as generalOnboarding } from './generalOnboarding';
import { createGeneralProductSubscriptionsRepository as generalProductSubscriptions } from './generalProductSubscriptions';
import { createGeneralServiceDocumentsRepository as generalServiceDocuments } from './generalServiceDocuments';
import { createGeneralSubscriptionsRepository as generalSubscriptions } from './generalSubscriptions';
import { createGeneralUserMergeRequestsRepository as generalUserMergeRequests } from './generalUserMergeRequests';
import { createGeneralUsersRepository as generalUsers } from './generalUsers';

export * from './types';

export const generalApiBasePath = '/api/general/v1';

export const generalRestRepositoryFactories = {
    generalCities,
    generalEnterprises,
    generalExchangeRates,
    generalMerchantSubscriptions,
    generalOnboarding,
    generalProductSubscriptions,
    generalServiceDocuments,
    generalSubscriptions,
    generalUserMergeRequests,
    generalUsers,
};
